const InvoiceApprovalActionsStyles = {
  container: {
    p: 3
  },
  
  card: {
    p: 4, 
    borderRadius: '16px', 
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e5e7eb'
  },
  
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  },
  
  spinner: {
    display: 'inline-block', 
    width: '20px', 
    height: '20px', 
    borderRadius: '50%', 
    border: '3px solid rgba(255,255,255,0.3)', 
    borderTop: '3px solid #fff',
    animation: 'spin 1s linear infinite'
  },
  
  infoBox: {
    p: 3, 
    backgroundColor: 'rgba(25, 118, 210, 0.04)', 
    borderRadius: '12px',
    border: '2px solid rgba(25, 118, 210, 0.2)',
    mb: 3,
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)'
  },
  
  infoLink: { 
    p: 0, 
    mt: 1.5, 
    fontWeight: 600,
    fontSize: '0.95rem',
    textDecoration: 'none',
    color: theme => theme.palette.primary.main,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -2,
      left: 0,
      width: '100%',
      height: '2px',
      backgroundColor: 'currentColor',
      transform: 'scaleX(1)',
      transition: 'transform 0.2s ease'
    },
    '&:hover:after': {
      transform: 'scaleX(1.1)'
    }
  },
  
  noPermissionBox: {
    p: 3, 
    backgroundColor: '#fff8e1', 
    borderRadius: '12px',
    border: '2px solid #ffa726',
    mb: 3,
    textAlign: 'center',
    boxShadow: '0 2px 12px rgba(255, 167, 38, 0.15)'
  },
  
  noApprovalBox: {
    p: 3, 
    backgroundColor: '#ffebee', 
    borderRadius: '12px',
    border: '2px solid #ef5350',
    mb: 3,
    textAlign: 'center',
    boxShadow: '0 2px 12px rgba(239, 83, 80, 0.15)'
  },
  
  priceTooHighBox: {
    p: 3, 
    backgroundColor: '#ffebee', 
    borderRadius: '12px',
    border: '2px solid #ef5350',
    mb: 3,
    textAlign: 'center',
    boxShadow: '0 2px 12px rgba(239, 83, 80, 0.15)'
  },
  
  approveCard: {
    p: 3, 
    borderRadius: '16px', 
    border: '3px solid #4caf50',
    backgroundColor: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 4px 16px rgba(76, 175, 80, 0.2)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #4caf50, #66bb6a, #4caf50)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 3s infinite',
      '@keyframes shimmer': {
        '0%': { backgroundPosition: '200% 0' },
        '100%': { backgroundPosition: '-200% 0' }
      }
    },
    '&:hover': {
      boxShadow: '0 8px 24px rgba(76, 175, 80, 0.3)',
      transform: 'translateY(-4px)'
    }
  },
  
  rejectCard: {
    p: 3, 
    borderRadius: '16px',
    border: '3px solid #f44336',
    backgroundColor: 'linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 4px 16px rgba(244, 67, 54, 0.2)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #f44336, #ef5350, #f44336)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 3s infinite',
      '@keyframes shimmer': {
        '0%': { backgroundPosition: '200% 0' },
        '100%': { backgroundPosition: '-200% 0' }
      }
    },
    '&:hover': {
      boxShadow: '0 8px 24px rgba(244, 67, 54, 0.3)',
      transform: 'translateY(-4px)'
    }
  },
  
  headerBox: {
    display: 'flex', 
    alignItems: 'center', 
    mb: 2.5
  },
  
  statusBox: {
    textAlign: 'center', 
    p: 4
  },

  transferButton: {
    borderRadius: '10px',
    borderWidth: '2px',
    fontWeight: 600,
    textTransform: 'none',
    px: 3,
    py: 1.25,
    transition: 'all 0.2s ease',
    '&:hover': {
      borderWidth: '2px',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)'
    }
  },

  transferSection: {
    p: 3,
    mb: 3,
    bgcolor: 'rgba(25, 118, 210, 0.04)',
    borderRadius: '12px',
    border: '2px solid rgba(25, 118, 210, 0.2)',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)'
  },

  approveButton: {
    mt: 'auto',
    borderRadius: '12px',
    py: 1.75,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
      transition: 'left 0.5s ease'
    },
    '&:hover': {
      boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
      transform: 'translateY(-2px)',
      '&::before': {
        left: '100%'
      }
    },
    '&:active': {
      transform: 'translateY(0px)'
    },
    '&.Mui-disabled': {
      backgroundColor: theme => theme.palette.success.main + '80',
      color: 'white'
    }
  },

  rejectButton: {
    borderRadius: '12px',
    py: 1.75,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    borderWidth: '2px',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderWidth: '2px',
      boxShadow: '0 4px 16px rgba(244, 67, 54, 0.3)',
      transform: 'translateY(-2px)'
    },
    '&:active': {
      transform: 'translateY(0px)'
    },
    '&.Mui-disabled': {
      borderColor: theme => theme.palette.error.main + '80',
      color: theme => theme.palette.error.main + '80'
    }
  },

  commentNotice: {
    mb: 2,
    p: 2.5,
    bgcolor: 'rgba(76, 175, 80, 0.08)',
    borderRadius: '12px',
    border: '2px dashed',
    borderColor: 'success.main',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    position: 'relative',
    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.12)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: '0 4px 12px rgba(76, 175, 80, 0.2)'
    }
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease',
      '& fieldset': {
        borderColor: '#e5e7eb',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ef5350',
        borderWidth: '2px',
        boxShadow: '0 0 0 4px rgba(239, 83, 80, 0.1)'
      }
    }
  },

  transferApproverButton: {
    borderWidth: 2,
    borderRadius: 2,
    px: 3,
    py: 1,
    borderColor: '#1976d2',
    color: '#1565c0',
    fontWeight: 'bold',
    transition: 'all 0.3s',
    '&:hover': {
      borderWidth: 2,
      borderColor: '#1565c0',
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.25)'
    }
  },

  transferSectionContainer: {
    p: 3,
    mb: 2,
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    borderRadius: 3,
    border: '2px solid #64b5f6',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      background: 'linear-gradient(90deg, #1976d2, #42a5f5, #64b5f6)'
    }
  },

  sectionIconBox: (color = '#1976d2', endColor = '#42a5f5') => ({
    width: 36,
    height: 36,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${color} 0%, ${endColor} 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `0 2px 8px ${color}4d`
  }),

  sectionHeader: (color = '#1565c0') => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2
  }),

  sectionTitle: (color = '#1565c0') => ({
    fontWeight: 'bold',
    color: color
  }),


  modernSelect: (borderColor = '#64b5f6', hoverColor = '#42a5f5', focusColor = '#1976d2', bgColor = '#e3f2fd') => ({
    backgroundColor: 'white',
    borderRadius: 2,
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 2,
      borderColor: borderColor
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: hoverColor
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: focusColor
    }
  }),


  dropdownAvatar: (bgColor = '#1976d2') => ({
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: bgColor,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: 'bold'
  }),


  gradientActionButton: (startColor = '#1976d2', endColor = '#42a5f5', shadowColor = 'rgba(25, 118, 210, 0.35)') => ({
    whiteSpace: 'nowrap',
    borderRadius: 2,
    px: 3,
    py: 1.5,
    fontWeight: 'bold',
    background: `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`,
    boxShadow: `0 4px 14px ${shadowColor}`,
    transition: 'all 0.3s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: `0 6px 20px ${shadowColor.replace('0.35', '0.45')}`,
      background: `linear-gradient(135deg, ${startColor} 0%, ${startColor} 100%)`
    },
    '&:disabled': {
      background: '#e0e0e0'
    }
  }),


  clarificationButton: {
    borderWidth: 2,
    borderRadius: 2,
    px: 3,
    py: 1,
    borderColor: '#ff9800',
    color: '#f57c00',
    fontWeight: 'bold',
    transition: 'all 0.3s',
    '&:hover': {
      borderWidth: 2,
      borderColor: '#f57c00',
      backgroundColor: 'rgba(255, 152, 0, 0.08)',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(255, 152, 0, 0.25)'
    }
  },


  clarificationChip: {
    alignSelf: 'center',
    backgroundColor: '#fff3e0',
    color: '#e65100',
    fontWeight: 'bold',
    border: '1px solid #ffb74d'
  },


  clarificationSectionContainer: {
    p: 3,
    mb: 2,
    background: 'linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)',
    borderRadius: 3,
    border: '2px solid #ffb74d',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      background: 'linear-gradient(90deg, #ff9800, #ffb74d, #ffc107)'
    }
  },


  clarificationDescription: {
    mb: 3,
    pl: 1,
    borderRight: '3px solid #ffb74d',
    pr: 2
  },


  modernTextField: (borderColor = '#ffb74d', hoverColor = '#ff9800', focusColor = '#f57c00') => ({
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 2,
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
        borderColor: borderColor
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: hoverColor
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: focusColor
      }
    }
  }),

 
  infoPaper: {
    p: 3,
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    borderRadius: 3,
    border: '2px solid #90caf9',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2
  },

  infoIconBox: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
  }
};

export default InvoiceApprovalActionsStyles;